import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { BrowserRouter } from 'react-router-dom';
import Routes from './pages';
import configureStore, { history } from './redux/store';
import AppWrapper from './components/AppWrapper';
import ErrorBoundary from './components/ErrorBoundary';
import { setAuthUser } from './redux/actions/auth';
export const store = configureStore();

const App = () => {
  const dispatch = store.dispatch;
  useEffect(() => {
    dispatch(setAuthUser());
  }, []);
  return (
    <ErrorBoundary>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <AppWrapper>
            <BrowserRouter>
              <Routes />
            </BrowserRouter>
          </AppWrapper>
        </ConnectedRouter>
      </Provider>
    </ErrorBoundary>
  );
};

export default App;
